<head>
    <title> {{ title }}</title>

    
</head>
<div style="display: flex; flex-direction: column; height: 100svh;">
    <header style="flex: 0 0 auto;">
        <app-navbar (menuClick)="isSidenavOpen = !isSidenavOpen" (isLoggedInEvent)="isLoggedIn = $event"></app-navbar>
    </header>
    <mat-sidenav-container style="display: flex; flex-direction: column; flex: 1 1 auto;">
        <mat-sidenav #sidenav class="sidenav" [(opened)]="isSidenavOpen" mode="over" (closedStart)="isSidenavOpen">
            <div class="side-nav">
                
                <h2 matSubheader class="sub-header">Tickets</h2>
                <button mat-button color="secondary" class="nav-bar-button" (click)="onpTicketsListClick()"
                *ngIf="isLoggedIn">
                <span>Overview</span>
                <mat-icon>home</mat-icon>
            </button>
            <h2 matSubheader class="sub-header">Reports</h2>
            <button mat-button (click)="onOpenReporting()" class="nav-bar-button"
            *ngIf="isLoggedIn"><mat-icon>map</mat-icon>Map</button>
            <button mat-button (click)="onOpenReportingOverview()" class="nav-bar-button"
            *ngIf="isLoggedIn">	<mat-icon>equalizer</mat-icon> Graphs</button>
            <button mat-button class="nav-bar-button" *ngIf="isLoggedIn" (click)="onAdministrationClick()">
            <mat-icon>manage_accounts</mat-icon> Administration
        </button>
        </div>


        </mat-sidenav>
        <mat-sidenav-content style="display: flex; flex-direction: column; flex: 1 1 auto;">



            <router-outlet></router-outlet>

        </mat-sidenav-content>
    </mat-sidenav-container>

</div>